import React from "react";
import { Star, ExternalLink, MapPin } from "lucide-react";
import { categories } from "../mock";

const PlaceCard = ({ place, onHover, isActive }) => {
  const cat = categories.find((c) => c.id === place.category);
  return (
    <div
      onMouseEnter={() => onHover && onHover(place.id)}
      onMouseLeave={() => onHover && onHover(null)}
      className={`group rounded-xl border bg-white p-4 transition-all duration-150 ${
        isActive
          ? "border-neutral-400 shadow-md"
          : "border-neutral-200 hover:border-neutral-300 hover:shadow-sm"
      }`}
    >
      <div className="flex items-start justify-between gap-3">
        <h3 className="text-[15px] font-semibold text-neutral-900 leading-snug">
          {place.name}
        </h3>
        {place.rating && (
          <div className="flex shrink-0 items-center gap-1 text-sm text-neutral-700">
            <Star className="h-3.5 w-3.5 fill-amber-400 text-amber-400" />
            <span className="font-medium">{place.rating}</span>
          </div>
        )}
      </div>

      <div className="mt-1.5 flex items-center gap-2 text-[13px] text-neutral-500">
        <span
          className="h-2 w-2 shrink-0 rounded-full"
          style={{ backgroundColor: cat?.color }}
        />
        <span>
          {place.type}
          {place.area ? ` · ${place.area}` : ""}
        </span>
      </div>

      <p className="mt-2.5 text-[14px] leading-relaxed text-neutral-600">
        {place.note}
      </p>

      <a
        href={place.maps}
        target="_blank"
        rel="noopener noreferrer"
        className="mt-3 inline-flex items-center gap-1 text-[13px] font-medium text-neutral-700 hover:text-neutral-900"
      >
        <MapPin className="h-3.5 w-3.5" />
        Google Maps
        <ExternalLink className="h-3 w-3" />
      </a>
    </div>
  );
};

export default PlaceCard;
